<template>
    <v-container class="mt-4">
        <task-progress :task="task"></task-progress>
    </v-container>
</template>

<script>
import TaskProgress from "@/components/Problem/TaskProgress.vue";

export default {
    components: { TaskProgress },
    data() {
        return {
            task: null,
            interval: null,
            loaded: false,
        }
    },
    watch: {
        async taskId() {
            this.$store.commit('grid/resetData');
            await this.loadTask();
        },
        loaded() {
            if (this.loaded && !this.taskFinished) {
                this.startMonitoring();
            }
        },
        taskFinished() {
            if (this.taskFinished) {
                this.stopMonitoring();
            }
        }
    },
    async created() {
        await this.loadTask();
    },
    methods: {      
        async loadTask() {
            this.loaded = false;
            this.task = await this.$store.dispatch('task/loadItemById', this.taskId);
            this.loaded = Boolean(this.task?.id);
        },
        startMonitoring() {
            this.interval = setInterval(async () => {
                await this.loadTask();
            }, 30000);
        },
        stopMonitoring() {
            if (!this.interval) {
                return;
            }

            clearInterval(this.interval);
        }
    },
    computed: {
        taskFinished() {
            if (!this.task) {
                return false;
            }

            return this.task?.status === 'finished';
        },
        taskHasError() {
            if (!this.task) {
                return false;
            }

            return Boolean(this.task?.error);
        },
        taskId() {
            return this.$route.params && this.$route.params.id
                ? this.$route.params.id || false
                : false;
        },
        saveError() {
            return this.$store.state.task.lastError;
        }
    }
}
</script>

<style lang="scss">
    .problem-edit {
        height: 100%;
        position: relative;
    }
</style>
